import React, { useState } from 'react';
import { Container, Form } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import TopHeader from '../Common/TopHeader';
import { DisplayErrorMessages, ActivateDeactivate, Checkeligibility, DisplayToaster, PostApiMethod, PutApiMethod, restrictIntialSpace, textValidator } from '../../core/services/apiService';
import { useForm } from 'react-hook-form';
import AppModal from '../AppModal/AppModal';


const AdminForm = () => {

    const location = useLocation();

    Checkeligibility("/super-admin/edit", location, "/super-admin");

    const { register, handleSubmit, formState: { errors }, setError } = useForm<any>();

    const [loader, setLoader] = useState(false);
    const [showPopUp, setShowPopUp] = React.useState<boolean>(false);

    const navigate = useNavigate();

    const pageDisable = () => {
        setLoader(true);
        document.body.classList.add('page-disable');
    };

    const pageEnable = () => {
        setLoader(false);
        document.body.classList.remove('page-disable');
    };

    const handleRegistration = (data: any) => {

        let postDate = {
            name: data.name.trim(),
            email: data.email.trim(),
            role: 'super_admin'
        }
        const payloadValue = [{ value: data.name, minLength: 4, maxLength: 40, key: 'name' }];
        const validation = textValidator(payloadValue);
        if (validation && validation.validation === true && validation.error) {
            validation.error.forEach(errorCase => {
                setError(errorCase.key, { type: errorCase.type });
            });
            return false;
        }
        pageDisable();
        location.pathname === '/super-admin/create' ?
            PostApiMethod('admin/user/', postDate)
                .then((res) => {
                    DisplayToaster("bg-success", "Super Admin " + data.name + " created successfully");
                    pageEnable();
                    navigate("/super-admin");
                })
                .catch((err) => {
                    pageEnable();
                    DisplayToaster("bg-danger", DisplayErrorMessages(err) ? DisplayErrorMessages(err) : "Something went wrong!");
                })
            :
            PutApiMethod('admin/user/' + location.state?.id, postDate)
                .then((res) => {
                    DisplayToaster("bg-success", "Super Admin " + data.name + " updated successfully");
                    pageEnable();
                    navigate("/super-admin");
                })
                .catch((err) => {
                    pageEnable();
                    let err_msg = "";
                    let cnt = 0;
                    if (err.response.data.errors !== undefined) {
                        err.response.data.errors.forEach((err: any, index: any) => {
                            cnt += 1;
                            err_msg += cnt + ". " + err.msg + "\n";
                        });
                    }
                    if (err.response.data.error !== undefined) {
                        err_msg = err.response.data.error ? err.response.data.error : "Something went wrong!";
                    }
                    DisplayToaster("bg-danger", DisplayErrorMessages(err) ? DisplayErrorMessages(err) : "Something went wrong!");
                })

    }
    return (
        <>
            <Container fluid className='mt-3'>
                <TopHeader
                    heading={(location.pathname === '/super-admin/create') ? "Create Super Admin" : (location.pathname === '/super-admin/edit') ? "Edit Super Admin - " + location.state?.names : " Super Admin"}
                    to={"/super-admin"}
                    className="fa-list"
                    action="List"
                    id="list-super-admin"
                />

                {
                    showPopUp &&
                    (
                        <AppModal
                            title={`Confirm To ${location.state.is_active ? "Deactivate" : "Activate"}!`}
                            bodyText={
                                `Are you sure to ${location.state.is_active ? "deactivate" : "activate"} this Super Admin ?`
                            }
                            primaryButtonLabel={"Yes"}
                            secondaryButtonLabel={"No"}
                            primaryButtonEventEmitter={() => {
                                ActivateDeactivate("Super Admin", location.state.names, "admin/user", location.state.id, location.state.is_active, () => { navigate('/super-admin') }); setShowPopUp(false)
                            }}
                            secondaryButtonEventEmitter={() => setShowPopUp(false)}
                        />
                    )
                }

                <div className='card' >
                    <div className='card-body'>
                        <Form onSubmit={handleSubmit(handleRegistration)} >
                            <div className='row mb-2'>
                                <div className='col-md-4'>
                                    <label>Name <span className='text-danger'>*</span></label>
                                </div>
                                <div className='col-md-4'>
                                    <input type="text" defaultValue={location.state?.names} onKeyDown={(e) => { restrictIntialSpace(e) }} className="form-control"
                                        {...register('name', {
                                            required: true, minLength: 4, maxLength: 40,
                                            pattern: {
                                                value: /^[a-zA-Z ]*$/,
                                                message: 'Name field should contain only alphabets',
                                            },
                                        })} />
                                    {errors.name && errors.name.type === "required" && <small className='text-danger' >Name is required</small>}
                                    {errors.name && errors.name.type === "minLength" && <small className='text-danger' >Minimum length should be 4 characters</small>}
                                    {errors.name && errors.name.type === "maxLength" && <small className='text-danger' >Maximum length should not exceed 40 characters</small>}
                                    {errors.name && errors.name.type === "pattern" && <small className='text-danger' >Name field should contain only alphabets</small>}
                                </div>
                            </div>

                            <div className='row mb-2'>
                                <div className='col-md-4'>
                                    <label>Email <span className='text-danger'>*</span></label>
                                </div>
                                <div className='col-md-4'>
                                    <input type="text"
                                        defaultValue={location.state?.emails}
                                        onKeyDown={(e) => { restrictIntialSpace(e) }}
                                        className="form-control" autoComplete="off"
                                        {...register('email',
                                            {
                                                required: true,
                                                pattern: {
                                                    value: /^\w+([\+\.-]?\w+)*@\w+([\+\.-]?\w+)*(\.\w{2,3})+$/,
                                                    message: 'Please enter a valid email',
                                                },
                                                setValueAs: (v) => v.trim()
                                            }
                                        )}
                                    />
                                    {errors.email && errors.email.type === "required" && <small className='text-danger' >Email is required</small>}
                                    {errors.email && errors.email.type === "pattern" && <small className='text-danger' >Please enter a valid email</small>}
                                </div>
                            </div>

                            {
                                location.pathname === '/super-admin/create' &&
                                <div className='row mb-2'>
                                    <div className='col-md-4'>
                                        <label>Role </label>
                                    </div>
                                    <div className='col-md-4'>
                                        <input type="text" name='super_admin' value="Super Admin" disabled className="form-control" />
                                    </div>
                                </div>
                            }

                            {
                                location.pathname === '/super-admin/edit' && location.state &&
                                <div className='row mb-2'>
                                    <div className='col-md-4'>
                                        <label>Status </label>
                                    </div>
                                    <div className='col-md-4'>
                                        <input type="text" className="form-control" value={location.state?.is_active ? "Active" : "Inactive"} disabled />
                                    </div>
                                </div>
                            }

                            <div className='text-center'>
                                <button type="submit" id="submit-super-admin" className='btn app-button-color btn-primary m-2'>
                                    {loader && (<span className="spinner-border text-white mr-1" style={{ width: '18px', height: "18px" }} role="status"></span>)}
                                    {location.pathname === '/super-admin/create' ? "Submit" : "Update"}
                                </button>
                                {location.pathname === '/super-admin/edit' && <button type="button" className={location.state?.is_active ? "btn btn-danger" : "btn btn-success"} onClick={(e) => { setShowPopUp(true) }}>{location.state?.is_active ? "Deactivate" : "Activate"}</button>}
                                <button type="button" id="cancel-super-admin" onClick={(e) => { navigate('/super-admin'); }} className='btn btn-secondary m-2'>Cancel</button>
                            </div>
                        </Form>

                    </div>
                </div>

            </Container >

        </>

    )
}
export default AdminForm;